import { render } from "./fake_receipt.vue?vue&type=template&id=5f21c931&scoped=true"
import script from "./fake_receipt.vue?vue&type=script&lang=js"
export * from "./fake_receipt.vue?vue&type=script&lang=js"

import "./fake_receipt.vue?vue&type=style&index=0&id=5f21c931&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f21c931"]])

export default __exports__